import { Injectable, Inject } from '@angular/core';
import { Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Servizio, StaticUrls, ServizioAcquistato } from '../models';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { MyCookieService } from './my-cookie.service';
import { AuthHttp, tokenNotExpired } from 'angular2-jwt';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Injectable()
export class ServizioAcquirenteService {

	private servizi: Servizio[];
	private serviziImmobile: ServizioAcquistato[];
	private idProfilo: number;
	private headers = new Headers({ 'Content-Type': 'application/json' });
	private options = new RequestOptions({ headers: this.headers });

	constructor(private http: AuthHttp,
		private router: Router, 
		@Inject(MyCookieService) private myCookieService: MyCookieService) { }

	getList(): Observable<Array<Servizio>> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._servizioAcquirente, this.options)
				.map(this.extractData)
				.catch(this.handleError);
		}
	}

	post(servizi: Servizio[]): Observable<Response> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			this.serviziImmobile = [];
			if(servizi != undefined){
				servizi.forEach(this.servizioForEachUtente.bind(this));
			}
			return this.http.post(StaticUrls._servizioAcquirente, this.serviziImmobile, this.options)
				.map( (response: Response) => { return response; })
				.catch(this.handleError);
		}
	}

	servizioForEachUtente(value: Servizio, index: number, array: Servizio[]) {
		this.serviziImmobile.push(new ServizioAcquistato(null, value.tipologiaServizio.id, value.costoScontato, this.idProfilo));
	}
	
	private extractData(res: Response) {
		this.servizi = res.json();
		return this.servizi;
	}

	private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
		} else {
			errMsg = error.message ? error.message : error.toString();
		}

		return Observable.throw(errMsg);
	}

	private ifTokenNotExpired() {
		if(this.myCookieService.token){
			if (!tokenNotExpired(environment.tokenName)) {
				this.router.navigate(['login']);
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/servizio-acquirente.service.ts